import { Component, Input,ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nbx-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class DatePickerComponent {

    // @Input() mode = 'range';
 
}